import { z } from 'zod/v4'
import { baseModelSchema } from '../../libs/base-model.ts'

export const projectStatusSchema = z.enum(['open', 'closed'])
export type ProjectStatus = z.infer<typeof projectStatusSchema>

export const projectModelSchema = baseModelSchema.extend({
  name: z.string(),
  clientId: z.string(),
  description: z.string().optional().nullable(),
  status: projectStatusSchema,
  isFavorite: z.boolean(),
  isArchived: z.boolean(),
  imageUrl: z.string().optional().nullable(),
  imageKey: z.string().optional().nullable(),
  deletedAt: z.iso.datetime().optional().nullable(),
})
export type ProjectModel = z.infer<typeof projectModelSchema>

export const projectCreateSchema = z.object({
  name: z.string(),
  clientId: z.string(),
  description: z.string().optional(),
  status: projectStatusSchema.optional(),
})
export type ProjectCreate = z.infer<typeof projectCreateSchema>

export const projectUpdateSchema = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
  status: projectStatusSchema.optional(),
  isFavorite: z.boolean().optional(),
  isArchived: z.boolean().optional(),
})
export type ProjectUpdate = z.infer<typeof projectUpdateSchema>
